module.exports = __webpack_public_path__ + "img/logo-skyhive.8dc41cd6.jpg";